import { GenericOAuth2 as OAuth2Client } from '@capacitor-community/generic-oauth2';
//import { OAuth2Client } from '@byteowls/capacitor-oauth2';
import { useStore } from '@/store/store';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import AppAPI from './AppAPI';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Intercom } from '@capacitor-community/intercom';
import { ref } from 'vue';
import * as Sentry from '@sentry/capacitor';

const urlBase = process.env.VUE_APP_URL_BASE;

export const accessToken = ref(
    (
        await SecureStoragePlugin.get({ key: 'accessToken' }).catch((error) => {
            console.log(error);
        })
    )?.value || ''
);
export const refreshToken = ref(
    (
        await SecureStoragePlugin.get({ key: 'refreshToken' }).catch((error) => {
            console.log(error);
        })
    )?.value || ''
);

export async function updateAuthTokens(newAccessToken: any, newRefreshToken: any) {
    SecureStoragePlugin.set({
        key: 'accessToken',
        value: newAccessToken,
    });

    SecureStoragePlugin.set({
        key: 'refreshToken',
        value: newRefreshToken,
    });

    accessToken.value = newAccessToken;
    refreshToken.value = newRefreshToken;
}

const openCapacitorSite = async () => {
    //web case logout
    if (Capacitor.getPlatform() === 'web') {
        if (process.env.VUE_APP_URL_BASE == 'https://127.0.0.1:8000') {
            window.location.href = process.env.VUE_APP_URL_BASE + '/logout/';
            window.location.href = process.env.VUE_APP_REDIRECT_URL;
        } else {
            window.location.href = process.env.VUE_APP_URL_BASE + '/logout/';
        }
        //window.location.href = process.env.VUE_APP_URL_BASE + '/logout/';
        return;
    }

    Browser.open({ url: process.env.VUE_APP_URL_BASE + '/logout/' });
    Browser.addListener('browserPageLoaded', async function () {
        if (Capacitor.getPlatform() === 'android') {
            //Browser.close();
            //window.location.href = 'com.lodgix.reservationapp://oauth';
            //navigator['app'].exitApp();
            //window.location.href = '/home';
            //window.close();
        }
        Browser.close().then(() => {
            window.location.href = '/home';
        });
    });
};

//lodgix app info
const oauth2Options = {
    authorizationBaseUrl: urlBase + '/o/authorize/',
    accessTokenEndpoint: urlBase + '/o/token/',
    resourceUrl: urlBase + '/o/api/userinfo/user/',
    logsEnabled: false,
    PKCE_REQUIRED: false,

    web: {
        appId: 'p7DMYI5yMgfCV7crTi4nmRAXiz6XgNkjdbl7xZus',
        responseType: 'code',
        pkceEnabled: true,
        //redirectUrl: window.location.origin,
        redirectUrl: process.env.VUE_APP_REDIRECT_URL,
        windowOptions: 'height=800,left=0,top=0',
        //windowTarget: '_blank',
    },
    android: {
        appId: 'p7DMYI5yMgfCV7crTi4nmRAXiz6XgNkjdbl7xZus',
        pkceEnabled: true,
        responseType: 'code',
        redirectUrl: 'com.lodgix.reservationapp://oauth',
    },
    ios: {
        appId: 'p7DMYI5yMgfCV7crTi4nmRAXiz6XgNkjdbl7xZus',
        pkceEnabled: true,
        responseType: 'code',
        redirectUrl: 'com.lodgix.reservationapp://oauth',
    },
};

const oauth2RefreshOptions = {
    appId: 'p7DMYI5yMgfCV7crTi4nmRAXiz6XgNkjdbl7xZus',
    accessTokenEndpoint: urlBase + '/o/token/',
    refreshToken: 'refreshToken.value',
};

let id = '';
let subscriber_id = '';
let email = '';
let name = '';
let lastName = '';
let loginType = '';

let lastCalled = Date.now() - 1000; // Initialize to 1 second ago
let isRefreshing = false;
const queue: Array<(value: boolean) => void> = [];

export default {
    authenticateWithLodgix: async () => {
        const store = useStore();
        try {
            //console.log("TRYING TO LOGIN...")
            const response = await OAuth2Client.authenticate(oauth2Options);
            accessToken.value = response['access_token'];
            id = response['id'];
            subscriber_id = response['subscriber_id'];
            email = response['email'];
            name = response['first_name'];
            lastName = response['last_name'];
            loginType = response['groups'][0]['name'];
            store.changeScope(response['access_token_response'].scope);

            try {
                refreshToken.value = response['access_token_response'].refresh_token;
            } catch (error) {
                console.log('Warning: ' + error);
            }

            name.concat(lastName);

            await updateAuthTokens(accessToken.value, refreshToken.value);

            SecureStoragePlugin.set({
                key: 'loginType',
                value: loginType,
            });

            SecureStoragePlugin.set({
                key: 'lang',
                value: 'en',
            });

            store.changeId(id);
            store.changeSubId(subscriber_id);
            store.changeEmail(email);
            store.changeLoginType(loginType);
            store.changeLang('en');
            store.changePushNotificationOpenId('');

            //load in user info
            try {
                const userData = await AppAPI.getUserInformation();
                store.changeName(userData.data.first_name);
                store.changeLastName(userData.data.last_name);
                store.changeEmail(userData.data.email);
                store.changeCurrency(userData.data.currency.code);
                store.changeCurrencySymbol(userData.data.currency.symbol);
                store.changeId(userData.data.id);
                store.changeSubId(userData.data.subscriber_id);
                store.changeCompanyEmail(userData.data.company.email);
                store.changeCompanyName(userData.data.company.title);
                store.changeCompanyLogo(userData.data.website.logo_url);
                store.changeCompanyAddress(userData.data.company.address);
                store.changeCompanyWebsite(userData.data.company.website);
                store.changeCompanyPhone(userData.data.company.phone);
                store.changeChatUserId(userData.data.chat_user_id);
                store.changeWebsocketToken(userData.data.websocket_token);
                store.changeWebsocketUrl(userData.data.websocket_url);
                store.changeCalendarTapeOptions(userData.data.calendar_tape_options);
                store.changeInboxPermissions(userData.data.permissions);
            } catch (err) {
                //console.log(err);
            }
            await AppAPI.logStatistic().catch((error) => {
                console.log('Error: ' + error);
            });

            //set up intercom verification
            if (Capacitor.getPlatform() === 'web') {
                return loginType;
            } else if (loginType == 'Subscriber' || loginType == 'Super User' || loginType == 'Front Desk') {
                Intercom.registerIdentifiedUser({ email: store.UserEmail });
                const hash = await AppAPI.getIntercomHash(Capacitor.getPlatform());
                Intercom.setUserHash({ hmac: hash.data.code });
                Intercom.updateUser({
                    name: store.UserFirstName + ' ' + store.UserLastName,
                    customAttributes: { account_type: loginType },
                });
            } else if (loginType == 'Cleaning Staff') {
                Intercom.registerIdentifiedUser({ email: store.UserEmail });
                const hash = await AppAPI.getIntercomHash(Capacitor.getPlatform());
                Intercom.setUserHash({ hmac: hash.data.code });
                Intercom.updateUser({
                    name: store.UserFirstName + ' ' + store.UserLastName,
                    customAttributes: { account_type: 'Cleaning Staff' },
                });
            }
        } catch (error: any) {
            //console.log('LOGIN_ERROR: ' + error);
            //console.log('page_url_1:' + JSON.stringify(window.location));
            if (error.includes('TypeError: undefinded is not an object')) {
                return 'ADMIN_LOGIN_ERROR';
            }

            return error;
        }

        return loginType;
    },

    refresh: async () => {
        if (Capacitor.getPlatform() === 'web') {
            return false;
        }

        return new Promise((resolve) => {
            queue.push(resolve);

            const now = Date.now();
            if (now - lastCalled < 1000 || isRefreshing) {
                // If less than 1 second has passed or refresh is in progress
                return;
            }

            lastCalled = now; // Update the last called time
            isRefreshing = true;

            (async () => {
                let result = false;
                try {
                    oauth2RefreshOptions.refreshToken = refreshToken.value;
                    const response = await OAuth2Client.refreshToken(oauth2RefreshOptions);
                    const access_token = response['access_token'];
                    const refresh_token = response['refresh_token'];
                    await updateAuthTokens(access_token, refresh_token);
                    result = true;
                } catch (error) {
                    //Sentry.captureMessage('RefreshToken Error: ' + error);
                    console.log('RefreshToken Error: ' + error);
                }

                await AppAPI.logStatistic();
                isRefreshing = false;

                // Resolve all promises in the queue
                while (queue.length > 0) {
                    const resolve = queue.shift();
                    if (resolve) {
                        resolve(result);
                    }
                }
            })();
        });
    },

    logout: async (doRedirect: boolean) => {
        const store = useStore();
        if (Capacitor.getPlatform() != 'web') {
            PushNotifications.removeAllDeliveredNotifications();
        }
        store.changeActivePage('/home');
        try {
            await AppAPI.deactivateDevice(store.PushNotificationToken);
        } catch (error) {
            console.log(error);
        }

        await OAuth2Client.logout(oauth2Options).then(async () => {
            //logout of intercom
            if (Capacitor.getPlatform() != 'web') {
                await Intercom.hideLauncher();
                await Intercom.logout();
            }

            //remove from localstorage
            SecureStoragePlugin.set({
                key: 'loginType',
                value: '',
            });

            await updateAuthTokens('', '');

            SecureStoragePlugin.set({
                key: 'notificationList',
                value: '',
            });
            SecureStoragePlugin.set({
                key: 'lang',
                value: 'en',
            });

            store.changeLoginType('');
            store.changeName('');
            store.changeLastName('');

            store.changeEmail('');
            store.changeCurrency('');
            store.changeCurrencySymbol('');
            store.changeReservationFirstName('');
            store.changeReservationLastName('');
            store.changeReservationEmail('');
            store.changeReservationStartDate('');
            store.changeReservationEndDate('');
            store.changeReservationSelectedProperty('');
            store.changeReservationSelectedPropertyId('');
            store.changeReservationAdults('');
            store.changeReservationChildren('');
            store.changeReservationPets('');
            store.changeReservationDateEntered('');
            store.changeReservationReservationType('');
            store.changeReservationTaxExemption('');
            store.changeReservationConfirmationAmount('');
            store.changeCompanyEmail('');
            store.changeCompanyName('');
            store.changeCompanyLogo('');
            store.changeCompanyAddress('');
            store.changeCompanyWebsite('');
            store.changeCompanyPhone('');
            store.changePushNotificationToken('');
            store.changeLoginType('');
            store.changeId('');
            store.changeSubId('');
            store.changeLang('en');

            store.changeDepartureDataCount(0);
            store.changeDepartureDataArray('');
            store.changeArrivalDataCount(0);
            store.changeArrivalDataArray('');
            store.changePendingDataCount(0);
            store.changePendingDataArray('');
            store.changeOccupancyAmount('');
            store.changeArrivalAmount('');
            store.changeDepartureAmount('');
            store.changePendingAmount('');
            store.changePushNotificationOpenId('');
            store.changeCalendarTapeOptions('');

            store.changeChatUserId('');
            store.changeWebsocketToken('');
            store.changeWebsocketUrl('');

            store.changeScope('');

            store.changeWorkOrderList([]);
            store.changeWorkOrderListTotal(0);
            store.changeWorkOrderJobTypes([]);
            store.changeWorkOrderVendors([]);
            store.changeWorkOrderExpenseAccounts([]);
            store.changeWorkOrderFormOptions([]);
            store.changeWorkOrderFormProperties([]);
            store.changeWorkOrderTeamMembers([]);
            store.changeWorkOrderPermissions({
                can_add: false,
                can_delete: false,
                has_add_access: false,
                has_base_work_order_access: false,
                has_config_access: false,
                has_delete_access: false,
                has_modify_access: false,
                is_close_disabled: false,
                is_modify_disabled: false,
                is_subscriber: false,
            });

            //force full logout of lodgix account one device
            if (doRedirect) {
                openCapacitorSite();
            }
        });
    },
};
